export default __webpack_public_path__ + "static/media/manikaran gurudwara1.2f3e2bfd.jpg";